import styled from 'styled-components';

const ButtonWrapper = styled.div`
  margin: ${props => (props.margin ? props.margin : '0 auto')};
  max-width: 500px;
  text-align: ${props => (props.align ? props.align : 'center')};
`;

export { ButtonWrapper };
